<div [class]="componentClass" style="position: relative">
	<div class="row" *ngIf="labelPlacement === 'top'">
		<label
			class="form-label fw-semibold"
			[attr.for]="id"
			style="margin-bottom: 10px">
			{{ label }}<span class="text-danger" *ngIf="isRequired">*</span>
		</label>
	</div>

	<label
		*ngIf="labelPlacement === 'start'"
		class="mr-3 form-check-label"
		[attr.for]="id"
		(click)="changeCheck(); $event.preventDefault()"
		style="margin-right: 10px">
		{{ label }}<span class="text-danger" *ngIf="isRequired">*</span>
	</label>

	<div class="checkbox-div">
		<input
			class="form-check-input"
			[ngClass]="{ ios: iosStyle }"
			type="checkbox"
			[formControlName]="controlName"
			[id]="id"
			[disabled]="disabled" />

		<label
			*ngIf="labelPlacement === 'end'"
			class="form-check-label checkbox-label"
			[attr.for]="id"
			(click)="changeCheck(); $event.preventDefault()">
			{{ label }}<span class="text-danger" *ngIf="isRequired">*</span>
		</label>
	</div>

	<div class="invalid-feedback mt-0" *ngIf="showsTextRequired || seiraError">
		{{ textRequired || seiraError }}
	</div>
</div>
